import ChalkySticks from '@chalkysticks/sdk';
import Store from '@/Store';

/**
 * Whether sync manager has been initialized
 *
 * @type boolean
 */
let hasInitialized: boolean = false;

/**
 * Initialize sync event listeners.
 *
 * @return void
 */
export function initialize(): void {
	if (hasInitialized) {
		return;
	}

	ChalkySticks.Core.Event.Bus.on('user.media:remove', () => {
		Store.dispatch('authentication/updateUser');
	});

	ChalkySticks.Core.Event.Bus.on('user.avatar:set', () => {
		Store.dispatch('authentication/updateUser');
	});

	hasInitialized = true;
}
